import { shouldForwardPrimitiveProp as e } from "./primitiveProps.mjs";
import { styled as t } from "styled-components";
//#region src/components/Primitives/Box.tsx
var n = (e, t) => {
	if (e !== void 0) return typeof e == "number" ? t(e) : e;
}, r = (e) => {
	if (e !== void 0) return typeof e == "number" ? `${e}px` : e;
}, i = t.div.withConfig({ shouldForwardProp: e })`
    ${({ theme: e, p: t }) => t === void 0 ? "" : `padding: ${n(t, e.spacing)};`}
    ${({ theme: e, px: t }) => t === void 0 ? "" : `padding-left: ${n(t, e.spacing)}; padding-right: ${n(t, e.spacing)};`}
    ${({ theme: e, py: t }) => t === void 0 ? "" : `padding-top: ${n(t, e.spacing)}; padding-bottom: ${n(t, e.spacing)};`}
    ${({ theme: e, pt: t }) => t === void 0 ? "" : `padding-top: ${n(t, e.spacing)};`}
    ${({ theme: e, pb: t }) => t === void 0 ? "" : `padding-bottom: ${n(t, e.spacing)};`}
    ${({ theme: e, pl: t }) => t === void 0 ? "" : `padding-left: ${n(t, e.spacing)};`}
    ${({ theme: e, pr: t }) => t === void 0 ? "" : `padding-right: ${n(t, e.spacing)};`}

    ${({ theme: e, m: t }) => t === void 0 ? "" : `margin: ${n(t, e.spacing)};`}
    ${({ theme: e, mx: t }) => t === void 0 ? "" : `margin-left: ${n(t, e.spacing)}; margin-right: ${n(t, e.spacing)};`}
    ${({ theme: e, my: t }) => t === void 0 ? "" : `margin-top: ${n(t, e.spacing)}; margin-bottom: ${n(t, e.spacing)};`}
    ${({ theme: e, mt: t }) => t === void 0 ? "" : `margin-top: ${n(t, e.spacing)};`}
    ${({ theme: e, mb: t }) => t === void 0 ? "" : `margin-bottom: ${n(t, e.spacing)};`}
    ${({ theme: e, ml: t }) => t === void 0 ? "" : `margin-left: ${n(t, e.spacing)};`}
    ${({ theme: e, mr: t }) => t === void 0 ? "" : `margin-right: ${n(t, e.spacing)};`}

    ${({ w: e }) => e === void 0 ? "" : `width: ${r(e)};`}
    ${({ h: e }) => e === void 0 ? "" : `height: ${r(e)};`}
    ${({ minW: e }) => e === void 0 ? "" : `min-width: ${r(e)};`}
    ${({ minH: e }) => e === void 0 ? "" : `min-height: ${r(e)};`}
    ${({ maxW: e }) => e === void 0 ? "" : `max-width: ${r(e)};`}
    ${({ maxH: e }) => e === void 0 ? "" : `max-height: ${r(e)};`}

    ${({ display: e }) => e ? `display: ${e};` : ""}
    ${({ overflow: e }) => e ? `overflow: ${e};` : ""}
    ${({ overflowX: e }) => e ? `overflow-x: ${e};` : ""}
    ${({ overflowY: e }) => e ? `overflow-y: ${e};` : ""}

    ${({ bg: e }) => e ? `background: ${e};` : ""}
    ${({ theme: e, radius: t }) => t ? `border-radius: ${t in e.radii ? e.radii[t] : t};` : ""}
    ${({ border: e }) => e ? `border: ${e};` : ""}
    ${({ theme: e, borderColor: t }) => t ? `border-color: ${t};` : ""}
    ${({ theme: e, shadow: t }) => t ? `box-shadow: ${t in e.shadows ? e.shadows[t] : t};` : ""}
    ${({ opacity: e }) => e === void 0 ? "" : `opacity: ${e};`}

    ${({ position: e }) => e ? `position: ${e};` : ""}
    ${({ theme: e, top: t }) => t === void 0 ? "" : `top: ${n(t, e.spacing)};`}
    ${({ theme: e, right: t }) => t === void 0 ? "" : `right: ${n(t, e.spacing)};`}
    ${({ theme: e, bottom: t }) => t === void 0 ? "" : `bottom: ${n(t, e.spacing)};`}
    ${({ theme: e, left: t }) => t === void 0 ? "" : `left: ${n(t, e.spacing)};`}
    ${({ zIndex: e }) => e === void 0 ? "" : `z-index: ${e};`}

    ${({ flex: e }) => e === void 0 ? "" : `flex: ${e};`}
    ${({ flexShrink: e }) => e === void 0 ? "" : `flex-shrink: ${e};`}
    ${({ flexGrow: e }) => e === void 0 ? "" : `flex-grow: ${e};`}
    ${({ alignSelf: e }) => e ? `align-self: ${e};` : ""}

    ${({ cursor: e }) => e ? `cursor: ${e};` : ""}
`;
i.displayName = "Box";
//#endregion
export { i as Box };
